
        document.addEventListener('DOMContentLoaded', function () {
            var links = document.querySelectorAll('a[href*="youtube.com"]');
            
            links.forEach(function (link) {
                link.setAttribute('target', '_blank');
            });
        });


 document.addEventListener('DOMContentLoaded', function () {
            var links = document.querySelectorAll('a[href*="plant.deergro.com"]');
            
            links.forEach(function (link) {
                link.setAttribute('target', '_blank');
            });
        });

document.addEventListener('DOMContentLoaded', function () {
            var links = document.querySelectorAll('a[href*="plan.deergro.com"]');
            
            links.forEach(function (link) {
                link.setAttribute('target', '_blank');
            });
        });








